<template>
    <div class="flex">
        <a href="#" title="Reminders" class="text-base p-4 flex hover:text-yellow-200 text-white"
           @click.prevent="openIt()">
            <i class="fas fa-check-square"></i>
        </a>
        <span v-if="todoCount > 0"
              class="absolute ml-6 items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-600 text-white">
          {{ todoCount }}
        </span>
        <slideover name="reminders" ref="slideover" v-if="typeof user === 'object'"
                   :content-class="'mt-1 px-6 overflow-y-auto h-full'">
            <template v-slot:title>
                <div class="flex h-10">
                    <div class="-mt-1.5 -ml-2">
                        <div class="inline-block text-gray-800 mt-0 pt-1 pb-0.5 px-2">Reminders
                        </div>
                        <span class="text-gray-300 text-sm mt-0 ml-2"><span
                            class="far fa-keyboard mr-1"></span>R</span>
                    </div>
                </div>
            </template>
            <template>
                <div :key="key">
                    <div
                        class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-14 flex items-center sticky sticky-top top-0 z-20">
                        <div class="flex-grow">Todo</div>
                        <div
                            class="pl-l mt-1 border-gray-200 border rounded text-gray-500 hover:text-brand text-xs py-0.5 px-1.5 bg-white hover:bg-gray-50 font-medium cursor-pointer"
                            @click="addReminder">
                            <span class="mx-px my-0.5 text-xs fa fa-plus"></span>
                        </div>
                    </div>
                    <ul class="flex-1 divide-y divide-gray-200 overflow-none" v-if="todo.length || addingItem"
                        :key="reminderKey">
                        <li v-for="item in todo" :key="item.id">
                            <reminder-item :item="item" ref="reminderItems" :packages="packages"
                                       @editFinished="finishedEditing"></reminder-item>
                        </li>
                    </ul>
                    <div v-if="!todo.length && !addingItem">
                        <a type="button" @click="addReminder"
                           class="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand">
                            <i class="far fa-smile-beam text-4xl text-gray-400"></i>
                            <span class="mt-4 block font-medium text-lg text-gray-700">You're Up To Date</span>
                            <span class="mt-1 block text-sm text-gray-700">Click to add a Reminder</span>
                        </a>
                    </div>
                    <div v-if="completed.length > 0"
                         class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-14 flex items-center sticky sticky-top top-0 z-20">
                        <div class="flex-grow" v-text="showAll?'All Completed':'Completed Today'"></div>
                        <div
                            class="pl-l mt-1 border-gray-200 border rounded text-gray-500 hover:text-brand text-xs py-0.5 px-1.5 bg-white hover:bg-gray-50 font-medium cursor-pointer"
                            @click="toggleShowAll">
                            <span class="mx-px my-0.5 text-xs"
                                  v-text="showAll?'Show completed today':'Show all completed'"></span>
                        </div>
                    </div>
                    <div v-else-if="!showAll"
                         class="pl-1 text-brand bg-white font-semibold text-lg h-14 flex items-center sticky sticky-top top-0 z-20">
                        <div class="flex-grow"></div>
                        <div
                            class="pl-l mt-1 border-gray-200 border rounded text-gray-500 hover:text-brand text-xs py-0.5 px-1.5 bg-white hover:bg-gray-50 font-medium cursor-pointer"
                            @click="toggleShowAll">
                            <span class="mx-px my-0.5 text-xs">Show all completed</span>
                        </div>
                    </div>
                    <ul class="flex-1 divide-y divide-gray-200 overflow-none" v-if="completed.length > 0">
                        <li v-for="item in completed" :key="item.id">
                            <reminder-item :item="item" :packages="packages" @editFinished="finishedEditing"></reminder-item>
                        </li>
                    </ul>
                </div>
            </template>
        </slideover>
    </div>
</template>

<script>


import PageCell from "../../ui/PageCell.vue";
import ReminderItem from "./ReminderItem.vue";
import moment from "moment-timezone";
import {uuid} from "../../../utils";
import {Package} from "@models";
import User from "../../../services/User";

export default {
    components: {
        ReminderItem, PageCell
    },
    props: {},
    data() {
        return {
            user: null,
            items: [],
            packages: [],
            key: 0,
            addingItem: false,
            reminderKey: 0,
            showAll: false,
        }
    },
    computed: {
        todoCount() {
            this.key && this.reminderKey && this.showAll
            return this.items.filter((i) => i.status === 'Todo').length
        },
        todo() {
            this.key && this.reminderKey && this.showAll
            return this.items.filter((i) => i.status === 'Todo')
        },
        completed() {
            this.key && this.reminderKey && this.showAll
            let left = this.todo.map((x) => x.id)
            let results = this.items.filter((i) => !left.includes(i.id) && i.completed);
            if (!this.showAll) {
                let validToday = moment().format("YYYY-MM-DD");
                return results.filter((i) => (moment(i.completed).format("YYYY-MM-DD") === validToday));
            }
            return results
        }
    },
    methods: {
        toggleShowAll() {
            this.showAll = !this.showAll;
        },
        finishedEditing() {
            this.items = this.items.filter((i) => {
                return !i.isNew
            })
            this.addingItem = false
            this.reminderKey++;
        },
        addReminder() {
            let reminder = {
                id: uuid(),
                description: '',
                dueDate: null,
                packageReference: null,
                packageName: null,
                status: 'Todo',
                completed: null,
                isNew: true,
                notifications:[],
            }
            this.addingItem = true;
            this.items.splice(0, 0, reminder);
            this.reminderKey++;
            this.key++;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.reminderItems.find((o) => o.$props.item.id === reminder.id).editing('description')
                })
            })
        },
        close() {
            this.finishedEditing()
            if (!this.hidden) {
                this.hidden = true;
                eventBus.$emit('slideover-close-reminders');
            }
        },
        async openIt(data) {
            this.updateReminders()
            window.Bus.emit('close-all-slideovers', '-reminders');
            eventBus.$emit('slideover-open-reminders');
            this.hidden = false;
        },
        deleteFromListener(data) {
            this.user.reminders = this.user.reminders.filter((i) => i.id !== data.data.id)
            this.items = this.items.filter((i) => i.id !== data.data.id)
            this.$nextTick(() => {
                this.key++
                this.$forceUpdate()
            })
            window.Bus.emit('reminders-todo', this.todoCount);
        },
        updateFromListener(data) {
            this.user.reminders = data.data.reminders
            let isEditing = false
            let known = []
            this.items.forEach((item) => {
                let newItem = data.data.reminders.find((i) => i.id === item.id);
                if (newItem) {
                    known.push(newItem.id)
                    item.isNew = false
                    Object.assign(item, newItem)
                    if (this.$refs.reminderItems) {
                        let ref = this.$refs.reminderItems.find((o) => o.$props.item.id === item.id)
                        if (ref) {
                            if (!ref.isEditing) {
                                ref.assignFromItem(item)
                                ref.$forceUpdate()
                            } else {
                                isEditing = true
                            }
                        }
                    }
                }
            })
            data.data.reminders.filter((i) => !known.includes(i.id)).forEach((i) => {
                this.user.reminders.splice(0, 0, i)
                this.items.splice(0, 0, i)
            })
            if (!isEditing) {
                this.$nextTick(() => {
                    this.key++
                    this.$forceUpdate()
                })
            }
            window.Bus.emit('reminders-todo', this.todoCount);
        },
        async updateReminders() {
            this.user = User.user;
            this.items = this.user.reminders
            this.items = this.items.filter((i) => {
                return !i.isNew
            })
            this.key++
        }
    },
    async mounted() {
        eventBus.$emit('slideover-set-scrollable-reminders', false);
        await User.register()
        User.registerAggregate({'type': 'User', 'id': User.user.id, 'event': 'RemindersUpdated'}, this.updateFromListener)
        User.registerAggregate({'type': 'User', 'id': User.user.id, 'event': 'ReminderDeleted'}, this.deleteFromListener)
        this.user = User.user;

        this.packages = (await Package.all(true))

        await this.updateReminders()

        window.Bus.on('close-all-slideovers', (e) => {
            if (e !== '-reminders') {
                this.close()
            }
        })

        eventBus.$on('slideover-opened', (e) => {
            if (e !== '-reminders') {
                this.close()
            }
        })

        window.Bus.on('show-package-filesystem', () => {
            this.close()
            this.disabledOpening = true;
        });

        window.Bus.on('close-package-filesystem', () => {
            this.disabledOpening = false;
        });

        window.Bus.on('open-reminders', (data) => {
            this.openIt(data)
        });

        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                this.close()
                return
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if (!this.disabledOpening) {
                if ((e.key === 'r') || (e.key === 'R')) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hidden) {
                        this.openIt()
                    } else {
                        this.close()
                    }
                }
            }
        })
        window.Bus.emit('reminder-widget-loaded');
        window.Bus.emit('reminders-todo', this.todoCount);
    }
}
</script>
